import { useCallback, useRef } from 'react';

export const useSignalHook = () => {
  const ref = useRef({
    signals: new Map<AbortController, () => void>(),
  });

  const clearSignals = useCallback(() => {
    ref.current.signals.forEach((item, key) => {
      item();
      ref.current.signals.delete(key);
    });
  }, []);

  const createSignal = useCallback(() => {
    const controller = new AbortController();
    ref.current.signals.set(controller, () => controller.abort());
    return controller;
  }, []);

  const removeCurrentSignal = useCallback((controller: AbortController) => {
    ref.current.signals.delete(controller);
  }, []);

  return {
    createSignal,
    clearSignals,
    removeCurrentSignal,
  };
};
